import SubscriptionCSP from "../../models/csp/SubscriptionCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  methods: {
    getAllSubscriptionIdsByTenantId: async function (tenantId: string) {
      const res = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${tenantId}/subscriptions`
      );
      return res.items
        .filter(sub => sub.status != "deleted")
        .map(sub => {
          return new SubscriptionCSP({
            id: sub.id,
            customerId: tenantId,
            friendlyName: sub.friendlyName,
            quantity: sub.quantity,
            unitType: sub.unitType,
            billingType: sub.billingType,
            status: sub.status,
            offerName: sub.offerName,
            creationDate: sub.creationDate,
            billingCycleEndDate: sub.billingCycleEndDate,
            commitmentEndDate: sub.commitmentEndDate,
            termDuration: sub.termDuration,
            billingCycle: sub.billingCycle,
            refundableQuantity: sub.refundableQuantity,
            autoRenewEnabled: sub.autoRenewEnabled,
            productId: sub.offerId.split(":")[0],
            skuId: sub.offerId.split(":")[1],
            links: sub.links
          });
        });
    },
    getAzurePlanIdsByTenantId: async function (tenantId: string) {
      const res = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${tenantId}/subscriptions`
      );
      return res.items
        .filter(
          sub =>
            sub.status === "active" &&
            (sub.offerName === "Azure plan" || sub.unitType === "Usage-based")
        )
        .map(sub => {
          const azurePlan = new SubscriptionCSP(undefined);
          azurePlan.setId = sub.id;
          azurePlan.setCustomerId = tenantId;
          return azurePlan;
        });
    },
    getSubscriptionByTenantIdAndSubscriptionId: async function (
      tenantId: string,
      subscriptionId: string
    ) {
      const res = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${tenantId}/subscriptions/${subscriptionId}`
      );

      return new SubscriptionCSP({
        id: res.id,
        customerId: tenantId,
        friendlyName: res.friendlyName,
        quantity: res.quantity,
        unitType: res.unitType,
        billingType: res.billingType,
        status: res.status,
        offerName: res.offerName,
        creationDate: res.creationDate,
        billingCycleEndDate: res.billingCycleEndDate,
        commitmentEndDate: res.commitmentEndDate,
        termDuration: res.termDuration,
        billingCycle: res.billingCycle,
        refundableQuantity: res.refundableQuantity,
        autoRenewEnabled: res.autoRenewEnabled,
        productId: res.offerId.split(":")[0],
        skuId: res.offerId.split(":")[1],
        links: res.links
      });
    },
    putSubscription: async function (
      tenantId: string,
      subscriptionId: string,
      body: Object
    ) {
      const endpoint = `${baseEndpointPartnerCenter}/customers/${tenantId}/subscriptions/${subscriptionId}`;
      await service.methods.patchEndpointAsync(endpoint, body);
    },
    getAvailabilities: async function (availabilitiesEndpoint: string) {
      try {
        const res = await service.methods.getEndpointAsync(
          `${baseEndpointPartnerCenter}${availabilitiesEndpoint}`
        );
        return res.terms;
      } catch (error) {
        throw error;
      }
    }
  }
};
